import { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { updateRouteItem } from "../../../../../../features/addLoad/addLoadSlice";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { showNestedModal } from "../../../../../../features/modal/modalSlice";

const Container = styled.div`
  width: 220px;
  height: 40px;
  filter: none !important;
  background-color: ${({ theme }) => theme.mainBgColor};
  position: relative;

  input {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-md);
    border: 1px solid
      ${({ theme, isActive, isError }) =>
        isError
          ? "var(--color-red)"
          : isActive
          ? "var(--color-main)"
          : theme.mainBorderColor};
    border-radius: ${({ radius }) => radius};
    color: var(--color-dark);
    background-color: ${({ theme }) => theme.mainBgColor};
    border-color: ${({ showErrors }) => showErrors && "var(--color-red)"};

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    &::-webkit-calendar-picker-indicator {
        filter: ${({ theme }) => theme.inputDateIconColor};
    }
  }

  input:focus ~ label {
    color: ${({ theme }) => theme.mainTextColor};
    transform: translateY(-22px);
    color: ${({ showErrors }) => showErrors && "var(--color-red)"};
  }

  label {
    position: absolute;
    transform: ${({ value }) => value && "translateY(-22px)"};
    bottom: 12px;
    left: 20px;
    font-size: 12px;
    font-weight: var(--font-weight-lg);
    pointer-events: none;
    transition: all 0.3s ease;
    z-index: 5;
    color: ${({ theme, value }) =>
      value ? theme.mainTextColor : theme.secondaryTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    color: ${({ showErrors }) => showErrors && "var(--color-red)"};
  }
  @media (max-width: 1200px){
        width: 150px !important;
    }
`;

const BosaltmaDateInput = ({ data, name, isRequired }) => {
  const [text, setText] = useState(data.date);
  const { showErrors, showRequiredPlaces, route } = useSelector(
    (state) => state.addLoad
  );
  const [isError, setIsError] = useState(false);

  //! datayı routeda bul ve kendinden önce gelen objeyi bul
  const findPreviousItem = (data, route) => {
    const dataIndex = route.findIndex((item) => item.id === data.id);
    if (dataIndex !== -1 && dataIndex > 0) {
      const previousItem = route[dataIndex - 1];
      return previousItem;
    }
    return null;
  };

  const previousItem = findPreviousItem(data, route);


  //! datayı routeda bul ve kendinden sonra gelen objeyi bul
  const findNextItem = (data, route) => {
    const dataIndex = route.findIndex(item => item.id === data.id); 
    if (dataIndex !== -1 && dataIndex < route.length - 1) { 
      const nextItem = route[dataIndex + 1]; 
      return nextItem;
    }
    return null; 
  };
  
  const nextItem = findNextItem(data, route);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    setText(e.target.value);

    const currentDate = new Date(e.target.value);
    const minDate = new Date().toJSON().slice(0, 10)
    
    //! bugünün tarihinden önce bir tarih girildi mi (ffk)
    if(currentDate?.toJSON()?.slice(0, 10) < minDate && data?.currentDateControl === false){
      dispatch(showNestedModal("beforeDateControlModal"));
      const updatedItem = {
        id: data.id,
        date: e.target.value,
        currentDateControl:true
      };
      dispatch(updateRouteItem(updatedItem));
    }else{
      const updatedItem = {
        id: data.id,
        date: e.target.value,
      };
      dispatch(updateRouteItem(updatedItem));
    }

    //! kendinden sonraki objenin date alanı ile arasındaki gün farkı
    // const newDate = new Date(e.target.value);
    const prevDate = new Date(nextItem?.date);
    
    if (currentDate > prevDate && data?.dateAfterInfo === false ) {
      dispatch(showNestedModal("dateAfterControlModal"));
      const updatedItem = {
        id: data.id,
        date: e.target.value,
        dateAfterInfo:true
      };
      dispatch(updateRouteItem(updatedItem));
    }else{
      const updatedItem = {
        id: data.id,
        date: e.target.value,
      };
      dispatch(updateRouteItem(updatedItem));
    }


    //! tarih karşılaştırması yapılıyor
    const previousDate = new Date(previousItem?.date);
    const differenceInTime = currentDate.getTime() - previousDate.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    // if (differenceInDays > 3) {
    //   dispatch(showNestedModal("dateControlModal"));
    // }

    // const updatedItem = {
    //     id: data.id,
    //     date: e.target.value
    // }

    // dispatch(updateRouteItem(updatedItem))

    if (differenceInDays > 3 && data?.dateInfo === false) {
      dispatch(showNestedModal("dateControlModal"));
      const updatedItem = {
        id: data.id,
        date: e.target.value,
        dateInfo: true,
      };
      dispatch(updateRouteItem(updatedItem));
    } else {
      const updatedItem = {
        id: data.id,
        date: e.target.value,
      };
      dispatch(updateRouteItem(updatedItem));
    }
  };

  useEffect(() => {
    setText(data.date);
  }, [data.date]);

  useEffect(() => {
    //! bu submit esnasında boş girerse gösterilecek
    if (isRequired && !data.date && showErrors) {
      return setIsError(true);
    }
    //! bu kullanıcı zorunlu alanları görüntülemek isterse
    if (isRequired && showRequiredPlaces) {
      return setIsError(true);
    } else {
      setIsError(false);
    }
  }, [isRequired, data.date, showRequiredPlaces, showErrors]);

 const minDate = new Date().toJSON().slice(0, 10)

  return (
    <Container value={text} radius={"5px"} isError={isError}>
      <input
        min={minDate}
        type="date"
        id={"text"}
        onChange={handleChange}
        value={text}
        name={name}
      />
      <label htmlFor={"text"}>Boşaltma Tarihi</label>
    </Container>
  );
};

export default BosaltmaDateInput;
